import { Field } from "enums";
import Validation from "services/validation.service";
import lang from "translations";

const initialFormState = (initialState = {}) => {
  const {
    defaultName = "",
    customName = "",
    capacity = 0,
    allowOnline = true,
    allowWalkIn = false,
    externalResourceId = "",

    locationId = null,
    resourceTypeId = null,
    resourceStatusId = null,
  } = initialState;
  return {
    defaultName: {
      name: "defaultName",
      value: defaultName,
      type: Field.INPUT,
      label: lang.defaultName || "Default Name",
      validations: [Validation.required()],
      required: true,
      maxLength: 75,
    },

    customName: {
      name: "customName",
      value: customName,
      type: Field.INPUT,
      label: lang.customName || "Custom Name",
      validations: [],
      required: false,
      maxLength: 75,
    },

    capacity: {
      name: "capacity",
      value: capacity,
      type: Field.NUMBER,
      label: lang.capacity || "Capacity",
      validations: [Validation.required()],
      required: true,
      maxLength: 10,
    },

    externalResourceId: {
      name: "externalResourceId",
      value: externalResourceId,
      type: Field.INPUT,
      label: lang.externalResourceId || "External Resource ID",
      validations: [],
      required: false,
      maxLength: 100,
    },

    locationId: {
      name: "locationId",
      value: locationId,
      type: Field.DROPDOWN,
      label: lang.location || "Location",
      validations: [Validation.required()],
      required: true,
    },

    allowOnline: {
      name: "allowOnline",
      value: allowOnline,
      type: Field.CHECKBOX,
      label: lang.allowOnline || "Allow Online",
    },

    allowWalkIn: {
      name: "allowWalkIn",
      value: allowWalkIn,
      type: Field.CHECKBOX,
      label: lang.allowWalkIn || "Allow Walk-In",
    },

    resourceTypeId: {
      name: "resourceTypeId",
      value: resourceTypeId,
      type: Field.DROPDOWN,
      label: lang.resourceType || "Resource Type",
      validations: [Validation.required()],
      required: true,
    },

    resourceStatusId: {
      name: "resourceStatusId",
      value: resourceStatusId,
      type: Field.DROPDOWN,
      label: lang.status || "Status",
      validations: [Validation.required()],
      required: true,
    },

  };
};

export default initialFormState;
